export default __webpack_public_path__ + "static/media/login_user.34c41fb8.svg";